import { memo } from 'react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { renderScorecardLinkCell } from './LinkCell';
import {
  formatRating,
  getCellStyle,
  getHeaderStyle,
  tableBaseStyle,
  tableCardHeaderStyle,
  tableCardStyle,
  tableScrollStyle,
  type ScorecardHistoryRow,
} from './styles';

// Hydrated by HtmlRenderer in browser contexts so the Activity column uses
// the Kula tooltip; the static HTML fallback ships in emails.

const ACTIVITY_CELL_MAX_WIDTH = '320px';

interface ScorecardHistoryTableProps {
  scorecards: ScorecardHistoryRow[];
}

export const ScorecardHistoryTable = memo<ScorecardHistoryTableProps>(
  function ScorecardHistoryTable({ scorecards }) {
    if (!scorecards || scorecards.length === 0) {
      return null;
    }
    return (
      <div style={tableScrollStyle}>
        <div style={tableCardStyle}>
          <div style={tableCardHeaderStyle}>Scorecard History</div>
          <table style={tableBaseStyle}>
            <thead>
              <tr>
                <th style={getHeaderStyle(true, false)}>
                  Interviewer/Reviewer
                </th>
                <th style={getHeaderStyle(false, false)}>Rating</th>
                <th style={getHeaderStyle(false, false)}>Activity</th>
                <th style={getHeaderStyle(false, true)}>Scorecard URL</th>
              </tr>
            </thead>
            <tbody>
              {scorecards.map((sc, idx) => {
                const isLastRow = idx === scorecards.length - 1;
                const rowKey = sc.scorecard_url ?? idx;
                return (
                  <tr key={rowKey}>
                    <td style={getCellStyle(true, false, isLastRow)}>
                      {sc.reviewer || '-'}
                    </td>
                    <td style={getCellStyle(false, false, isLastRow)}>
                      {formatRating(sc.rating)}
                    </td>
                    <td
                      style={{
                        ...getCellStyle(false, false, isLastRow),
                        maxWidth: ACTIVITY_CELL_MAX_WIDTH,
                      }}
                    >
                      {sc.activity ? (
                        <TruncatedTextWithTooltip
                          text={sc.activity}
                          placement="top"
                        />
                      ) : (
                        '-'
                      )}
                    </td>
                    <td style={getCellStyle(false, true, isLastRow)}>
                      {renderScorecardLinkCell(sc.scorecard_url)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
);
